import {
  documitraOrderStatusOption,
  documitraOrderStatusOption2,
  getDocumitraApplicationStatusFilterOptions,
  documitraPaymentStatusOption,
} from '../constants/AppConstant';
import { errorMsg } from '../constants/messages';

const DocumitraOrderApplication = [
  {
    name: 'orderId',
    label: 'ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    readonly: true,
    tableMeta: {
      title: 'Order ID',
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: false,
  },
  {
    name: 'review',
    label: 'Add Ons',
    fieldType: {
      name: 'reviewDocumitraOrder',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Add Ons', columnType: 'clickHere', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: true,
    preserveAccordionStyles: true,
    default: '',
  },
  {
    name: 'plan',
    label: 'Plan',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Plan', allowAddRecordClick: false, columnType: 'orderPlan' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'userName',
    label: 'User Name',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'User Name', allowAddRecordClick: false, columnType: 'orderUserName' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'userEmail',
    label: 'User Email',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'User Email', allowAddRecordClick: false, columnType: 'orderUserEmail' },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'serviceName',
    label: 'Service Name',
    fieldType: {
      name: 'select',
      options: documitraOrderStatusOption,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Service Name', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'packageName',
    label: 'Package Name',
    fieldType: {
      name: 'select',
      options: documitraOrderStatusOption,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Package Name', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  // {
  //   name: 'status',
  //   label: 'Status',
  //   fieldType: {
  //     name: 'select',
  //     options:
  //       localStorage.getItem('role') === 'Super Admin'
  //         ? documitraOrderStatusOption
  //         : documitraOrderStatusOption2,
  //   },
  //   required: true,
  //   errorMsg: errorMsg,
  //   tableMeta: { title: 'Status', allowAddRecordClick: false },
  //   isTableHeader: true,
  //   isAccordian: true,
  //   default: '',
  // },

  {
    name: 'memberNames',
    label: 'Member Names',
    fieldType: {
      name: 'text',
    },
    required: false,
    errorMsg: errorMsg,
    tableMeta: { title: 'Member Names', columnType: 'memberNames', allowAddRecordClick: true },
    isTableHeader: true,
    isAccordian: false,
    hideFromAbstractForm: true,
    default: '',
  },
  {
    name: 'memberStatus',
    label: 'Application Status',
    fieldType: {
      name: 'select',
      options: getDocumitraApplicationStatusFilterOptions(),
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: 'Order Status',
      columnType: 'memberStatus',
      allowAddRecordClick: true,
    },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },

  {
    name: 'paymentStatus',
    label: 'Payment Status',
    fieldType: {
      name: 'select',
      options: documitraPaymentStatusOption,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Payment Status', allowAddRecordClick: false, columnType: 'paymentStatus' },
    isTableHeader: true,
    isAccordian: true,
    hideFromAbstractForm: true,
    default: '',
  },
  {
    name: 'createdAt',
    label: 'Order Date',
    fieldType: {
      name: 'select',
      options: documitraOrderStatusOption,
    },
    required: true,
    errorMsg: errorMsg,
    tableMeta: { title: 'Order Date', allowAddRecordClick: false },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
  {
    name: 'partnerId',
    label: 'Last Referral Partner ID',
    fieldType: {
      name: 'text',
    },
    required: false,
    readonly: true,
    errorMsg: errorMsg,
    tableMeta: {
      title: ' Referral Partner ID',
      allowAddRecordClick: false,
      columnType: 'lastReferralPartnerIdSeries',
    },
    isTableHeader: true,
    isAccordian: false,
    default: '',
  },
];

export { DocumitraOrderApplication };
